import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import 'focus-visible';
import { useDialogContext } from './context.js';
import { dialogSizes } from './constants.js';
import { jsx } from '@emotion/react';
import { Popup } from '../Popup/Popup.js';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '@floating-ui/react-dom';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';

const baseStyles = _ref => {
  let {
    isFullScreen,
    isMobile,
    size,
    type
  } = _ref;
  const customCSSProps = [];
  if (!isFullScreen && isMobile) {
    customCSSProps.push({
      borderTopLeftRadius: "md"
    });
    customCSSProps.push({
      borderTopRightRadius: "md"
    });
  }
  return {
    boxShadow: isMobile && type === "popup" ? "mobilePopover" : "none",
    backgroundColor: "background",
    border: isFullScreen || isMobile ? "none" : "1px solid",
    borderColor: "border.weak",
    borderRadius: isFullScreen || isMobile ? 0 : "md",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    blockSize: isFullScreen ? "100%" : "auto",
    maxInlineSize: isFullScreen || isMobile ? "none" : dialogSizes[size],
    maxBlockSize: "100%",
    overflow: "hidden",
    paddingBlockEnd: isMobile ? 5 : 0,
    paddingBlockStart: 0,
    paddingInlineEnd: 0,
    paddingInlineStart: 0,
    position: "relative",
    inlineSize: "100%",
    zIndex: 2,
    "@media screen and (max-height: 32rem)": {
      overflow: "auto"
    },
    ":focus:not([data-focus-visible-added])": {
      boxShadow: isMobile && type === "popup" ? "mobilePopover" : "none"
    },
    ":focus": {
      outline: "none",
      boxShadow: _ref2 => {
        let {
          shadows
        } = _ref2;
        return [shadows.focus["[base]"], isMobile && type === "popup" ? shadows.mobilePopover : null].filter(x => x).join(", ");
      }
    },
    ...Object.assign({}, ...customCSSProps)
  };
};
const styleProps = new Set(["isFullScreen", "isMobile", "size", "type"]);
const StyledDialog = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "e1rjvi010"
} : {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "e1rjvi010",
  label: "StyledDialog"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const PopupStyledDialog = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    isFullScreen: _isFullScreen,
    isMobile: _isMobile,
    size: _size,
    type: _type,
    ...props
  } = _ref3;
  const {
    popupProps
  } = useDialogContext();
  const {
    sx,
    ...otherPopupProps
  } = popupProps;
  return jsx(Popup, _extends({
    ref: forwardedRef,
    showArrow: true,
    sx: {
      borderColor: "border.weak",
      variant: "text.level3",
      minInlineSize: "200px",
      maxInlineSize: "400px",
      zIndex: 2,
      ":focus:not([data-focus-visible-added])": {
        boxShadow: "medium"
      },
      ":focus": {
        outline: "none",
        boxShadow: _ref4 => {
          let {
            shadows
          } = _ref4;
          return [shadows.focus["[base]"], shadows.medium].join(", ");
        }
      },
      ...sx
    }
  }, otherPopupProps, props));
});
const DialogBase = /*#__PURE__*/forwardRef((_ref5, forwardedRef) => {
  let {
    role,
    ...remainingProps
  } = _ref5;
  const {
    hasDescription,
    id,
    isFullScreen,
    isMobile,
    size,
    type
  } = useDialogContext();
  const C = type === "popup" && !isMobile ? PopupStyledDialog : StyledDialog;
  return jsx(C, _extends({
    role: role
  }, remainingProps, hasDescription ? {
    "aria-describedby": `dialog-description-${id}`
  } : null, {
    "aria-labelledby": `dialog-title-${id}`,
    "aria-modal": true,
    isFullScreen: isFullScreen,
    isMobile: isMobile,
    ref: forwardedRef,
    size: size,
    type: type
  }));
});
DialogBase.displayName = "DialogBase";

export { DialogBase, StyledDialog };
